import React, { createContext, useReducer } from "react";
import Reducer from "./Reduser";

const initialState = {
     uiConfirmationDetails: {
          show: false,
          okFunction: () => {},
          cancelFunction: () => {},
          title: "Delete",
          contentDetails: "Are you sure want ot delete ?",
     },

     uiModalDetails: {
          show: false,
          icon: "",
          heading: "Delete",
          children: "Are you sure want ot delete ?",
     },

     uiLargeModalDetails: {
          show: false,
          heading: "Delete",
          children: "Are you sure want ot delete ?",
     },
     uiExtraLargeModalDetails: {
          show: false,
          heading: "Delete",
          children: "Are you sure want ot delete ?",
     },

     uiErrorMessageDetails: {
          show: false,
          icon: "",
          messages: ["Error message ?"],
     },

     uiSuccessMessageDetails: {
          show: false,
          icon: "",
          messages: ["Success"],
     },

     ui_sidebar_open: false,
     ui_sidebar_menu_open: false,


     campaign_header_content : "",

     signalRConnaction: null,
     ui_chat_box: {
          show: false,
          children: "",
      },
};

const ContextStore = ({ children }) => {
     const [state, dispatch] = useReducer(Reducer, initialState);
     return (
          <Context.Provider value={[state, dispatch]}>
               {children}
          </Context.Provider>
     );
};

export const Context = createContext(initialState);
export default ContextStore;
